var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReconciliation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.532,
    height: 32.492,
    viewBox: "0 0 28.532 32.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-reconciliation",
    transform: "translate(-4.567 -8.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M30.247,35.039a.377.377,0,0,1-.508-.35V33.461L25.3,36.734l4.443,3.277V38.525a.374.374,0,0,1,.3-.4,13.647,13.647,0,0,0,6.7-23.335L34.36,16.624a10.693,10.693,0,0,1-4.112,18.415Zm-5.613-20.63H24.7l.023,0a.377.377,0,0,1,.2.1l0,0a.377.377,0,0,1,.055.067l0,0a.369.369,0,0,1,.055.165c.035.38,0,.909,0,1.305l4.443-3.277L25.043,9.5v1.469a.377.377,0,0,1-.318.371A13.648,13.648,0,0,0,18.058,34.7l2.393-1.833a10.692,10.692,0,0,1,4.106-18.443.392.392,0,0,1,.077-.017Z",
    transform: "translate(-8.557)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(12 17.5)",
    fill: "#fff",
    stroke: "#696969",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M271.016,183v1.066c.623.033,2.214-.1,2.46.672h-2.46v.951h2.574a1.559,1.559,0,0,1-1.213.885l-1.361.033-.016.951,2.853,3.312h1.476l-2.689-3.3a2.425,2.425,0,0,0,2.279-1.935l1.033.033v-.9h-1.115a1.517,1.517,0,0,0-.312-.836h1.459V183Z",
    transform: "translate(-254.816 -162.204)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliation);
export default __webpack_public_path__ + "static/media/reconciliation.26a1dd7d19e7f06d41256b2b61baf7b2.svg";
export { ForwardRef as ReactComponent };